<h1 mat-dialog-title>{{ edit ? 'Kannbeschreibung bearbeiten' : 'Kannbeschreibung erstellen' }}</h1>
<mat-dialog-content class="w800 custom-scrollbar">
  <app-folder-usage-hint [entryId]="id" [type]="flavor === 'detailed' ? 'DETAILED_CDS_ENTRY' : 'GLOBAL_CDS_ENTRY'"></app-folder-usage-hint>
  <mat-vertical-stepper #stepper>
    <!-- general attributes -->
    <mat-step [stepControl]="formGroup" label="Allgemeine Informationen">
      <div class="pad-top8">
        <form [formGroup]="formGroup">
          <div>
            <mat-form-field appearance="outline" class="w100">
              <mat-label>Name</mat-label>
              <input formControlName="nameCtrl" matInput placeholder="" required>
            </mat-form-field>
          </div>
          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Rezeptiv</mat-label>
              <mat-select formControlName="receptive" placeholder="">
                <mat-option [value]="null">&mdash;</mat-option>
                @for (option of levelList; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w49">
              <mat-label>Produktiv</mat-label>
              <mat-select formControlName="productive" placeholder="">
                <mat-option [value]="null">&mdash;</mat-option>
                @for (option of levelList; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Modus</mat-label>
              <mat-select formControlName="mode" placeholder="">
                <mat-option [value]="null">&mdash;</mat-option>
                @for (option of modeList; track option) {
                  <mat-option [value]="option">{{ formOptionsLists.modesToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w49">
              <mat-label>Aktivität</mat-label>
              <mat-select formControlName="activity" placeholder="">
                <mat-option [value]="null">&mdash;</mat-option>
                @for (option of activityList; track option) {
                  <mat-option [value]="option">{{ formOptionsLists.activityToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div (click)="openCategorySelectionDialog()" tabindex="0" class="w100">
            <mat-form-field appearance="outline" class="w100">
              <mat-label>Thema</mat-label>
              <mat-select formControlName="categoryId" placeholder="" required>
                @if (selectedCategory) {
                  <mat-option [value]="selectedCategory.id">{{ selectedCategory.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </form>
        <div>
          <button matStepperNext color="primary" mat-raised-button>Weiter</button>
        </div>
      </div>
    </mat-step>
    <!-- references -->
    <mat-step label="Verweise">
      <app-reference-table [entry]="references" [editMode]="true" [clickableRefs]="false"
                           [selfId]="id"
                           [selfType]="flavor === 'detailed' ? 'det_can_statements' : 'glob_can_statements'"
                           (entryChange)="handleReferenceChange($event)"></app-reference-table>
      <button mat-raised-button matStepperPrevious>Zurück</button>
    </mat-step>
  </mat-vertical-stepper>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="save()" color="primary" mat-raised-button>Speichern</button>
</mat-dialog-actions>
